__turbopack_context__.v({
  "back": "style-module-scss-module__Ksfhbq__back",
  "button": "style-module-scss-module__Ksfhbq__button",
  "checkboxes": "style-module-scss-module__Ksfhbq__checkboxes",
  "error": "style-module-scss-module__Ksfhbq__error",
  "phone": "style-module-scss-module__Ksfhbq__phone",
  "root": "style-module-scss-module__Ksfhbq__root",
  "title": "style-module-scss-module__Ksfhbq__title",
});
